export type NotificationType =
  | "OPEN_CONSTRUCTION" // 공사 개시
  | "POLYGON" // 폴리곤

export interface NotificationTypeConfig {
  title: string;
  icon: string;
}

export const NOTIFICATION_TYPE_CONFIG: Record<NotificationType, NotificationTypeConfig> = {
  POLYGON: {
    title: "폴리곤",
    icon: "PolygonIcon",
  },
  OPEN_CONSTRUCTION: {
    title: "새로운 현장",
    icon: "SiteIcon",
  },
};
